import React from 'react'
import { List } from 'semantic-ui-react'

const ListShorthand = () => (
  <List className="my_contact_info">
    <List.Item icon='linkify' content={<a target="_blank"  rel="noopener noreferrer" href='http://adon988.logdown.com'>adon988.logdown.com</a>} />
    <List.Item icon='mail' content={<a  rel="noopener noreferrer" href='mailto:adon988@gmail.com'>adon988@gmail.com</a>} />
  </List>
)

export default ListShorthand


// WEBPACK FOOTER //
// ./src/components/ListShorthand.js